module.exports = __webpack_public_path__ + "img/daytime-results-1.ba8a1fc3.png";